import { useEffect } from 'react';
import { MODAL_COMPONENTS_MAP } from '../../lib/constants/modal.constants';
import { useModalStore } from '../../store/useModalStore';
import type { ModalComponentProps } from '../../types/modal.types';

export const GlobalModalRenderer = () => {
  const { modals, closeModal } = useModalStore();

  useEffect(() => {
    if (modals.length > 0) {
      const originalStyle = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      return () => {
        document.body.style.overflow = originalStyle;
      };
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [modals.length]);

  return (
    <>
      {modals.map(({ id, key, props }) => {
        const SpecificModalComponent = MODAL_COMPONENTS_MAP[key] as React.ComponentType<ModalComponentProps & unknown>;

        if (!SpecificModalComponent) {
          console.warn(
            `Modal component for key "${key}" not found in registry.`
          );
          return null;
        }

        return (
          <SpecificModalComponent
            key={id}
            {...props}
            id={id}
            onClose={() => closeModal(id)}
          />
        );
      })}
    </>
  );
};